export function gauge(ctx) {
    return {
        properties: {
            value_color: '#3b3e42',
            value_font:  32,
        },
        styles: {
            main: {
                ...ctx.pretty,
                radius: 999,
                padding: 10,
                scale_width: 9,
                scale_border_width: 0,
                line_width: 3,
                line_color: '#666666',
                scale_grad_color: '#666666',
                scale_end_color: ctx.primary,
            },
            indicator: {
                bg_color: '#464b5b',
                radius: 999,
                border_width: 0,
                line_color: '#3b3e42',
                line_width: 4,
            },
            major_ticks: {
                scale_width: 16,
                line_width: 4,
                line_color: '#666666',
                scale_grad_color: '#666666',
                scale_end_color: ctx.primary,
            },
        },
    };
}
